<template>
    <div ref="labelNodeSearchContainer" class="label-node-search__container" 
    :data-active="isActive" 
    :data-exec-mode="execMode" 
    :data-can-be-selected="hasReportLine"
    :data-cursor-active="isCursorActive"  @mouseover="onHoverTitle" @mouseleave="onLeaveTitle">
        
        <div v-if="node.layout.color"
            class="label-node-search__color"
            :style="{
                background : node.layout.color,
            }">
        </div>
        <span class="label-node-search__title" @click="selectLabel">
            <highlightText :text="captionText" :highlightedText="searchValue" />
            <span v-show="reportNode?.annotation.list?.length > 0" class="label-node-search__annotations" v-html="annotationsString"></span>
        </span>
        <CircleCheckIconSvg v-show="reportNode" class="label-node-search__check-icon" />

        <!-- <template v-show="canEdit && hasReportLine">
            <flatIconButton v-show="!reportNode" 
                text="Adicionar no Laudo" color="#2B536A" 
                @click="addLabelToReport">
                <AddIconSvg slot="svgIcon" />
            </flatIconButton>
            <flatIconButton v-show="reportNode" 
                :text="reportNode?.annotation.list?.length > 0 ? '' : 'Remover do Laudo'" color="#EF4444" 
                @click="removeLabelFromReport">
                <TrashCanIconSvg slot="svgIcon" />
            </flatIconButton>
        </template> -->
    </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { reportUtils } from '@/features/report/lib/reportUtils';
import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';
import highlightText from '@/components/ui/text/highlightText.vue';
import CircleCheckIconSvg from '@/assets/icons/circle-check.svg';


import ReportNode from '@/features/report/models/ReportNode';


export default {
    name: 'labelNodeSearch',
    components: {
        highlightText,
        CircleCheckIconSvg,
        // TrashCanIconSvg,
        // AddIconSvg,
        // flatIconButton
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        node: {
            type: Object,
            required: true
        },
        reportNode: {
            type: ReportNode,
            default: null
        },
        id: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        },
        searchMode: {
            type: Boolean,
            default: false
        },
        searchValue: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            gConsts: gConsts,
            canEdit: this.execMode == gConsts.rt.execModes.WORK,
            isActive: this.active,
            isCursorActive: false,
        }
    },

    watch: {
        active(newVal) {
            this.isActive = newVal;
        }
    },

    methods: {
        ...mapActions([
            'ACT_reportNodes_removeReportNode',
            'ACT_reportNodes_addNewLabelReportText',
        ]),

        selectLabel() {
            if (!this.hasReportLine)
                return
            if (!this.isActive) {
                this.addLabelToReport()
                // evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.node.id, nodeType: gConsts.node.layout.types.LABEL });
            }
            this.isActive = true;
            evtBus.$emit('evt_sidebarPanel_collapse');
        },

        addLabelToReport() {
            // Adiciona linha no report
            this.ACT_reportNodes_addNewLabelReportText({ labelId: this.node.id });
            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.node.id, nodeType: gConsts.node.layout.types.LABEL });
            // if (this.searchMode) {
            evtBus.$emit('evt_relatorioDinamico_addLabelToReport', { labelId: this.node.id });
            // }
        },
        
        // removeLabelFromReport() {
        //     // Remove linha do report
        //     if (this.isActive) {
        //         evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.node.id, nodeType: gConsts.node.layout.types.LABEL });
        //     }
        //     this.ACT_reportNodes_removeReportNode({ nodeId: this.node.id });
        // },

        onCursorChange(labelId) {
            if (labelId == this.node.id) {
                this.isCursorActive = true;
                if (this.$refs.labelNodeSearchContainer) {
                    this.$refs.labelNodeSearchContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            } else {
                this.isCursorActive = false;
            }
        },

        onHoverTitle() {
            evtBus.$emit('evt_tool_displayLabel', { label: this.node.id });
        },

        onLeaveTitle() {
            evtBus.$emit('evt_tool_displayLabel', { label: null });
        }
    },

    computed: {
        ...mapGetters([
        ]),

        annotationsString() {
            return reportUtils.getAnnotationsText(this.reportNode?.annotation.list || []);
        },

        captionText() {
            return this.node.layout.caption + (this.reportNode?.annotation.list?.length > 0 ? ' - ' : '');
        },

        hasReportLine() {
            return reportUtils.nodeHasReportLine(this.node);
        }
    },

    mounted() {
        evtBus.$on('evt_pesquisaAnotacoes_onCursorChange', this.onCursorChange);
    },
}
</script>

<style scoped>

.label-node-search__container {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    width: 100%;
    padding: var(--spacing-sm);
    box-sizing: border-box;
}

.label-node-search__container:hover, .label-node-search__container[data-cursor-active="true"] {
    background-color: color-mix(in srgb, var(--color-primary) 20%, transparent);
    border-radius: var(--radius-sm);
}

.label-node-search__check-icon {
    color: var(--color-primary);
    width: 15px;
    height: 15px;
    margin-left: auto;
    flex-shrink: 0;
}

.label-node-search__color {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: var(--radius-sm);
    flex-shrink: 0;
}

.label-node-search__container[data-active="true"] .label-node-search__title {
    font-weight: 700;
}

.label-node-search__container[data-can-be-selected="true"] .label-node-search__title {
    cursor: pointer;
}

.label-node-search__title {
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: var(--text-sm);
    color: var(--color-primary);
    line-height: 1;
    cursor: default;
    text-align: left;
    transition: all 0.2s ease;
}

.label-node-search__container:hover .label-node-search__title {
    opacity: 0.7;
}

.label-node-search__annotations {
    font-size: var(--text-xs);
    font-weight: 400;
    color: var(--color-secondary);
}


</style>